module.exports = __webpack_public_path__ + "img/industrial.44793571.svg";